var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var produce = require("immer").default;

var React = require("react");

module.exports.useImmer = function useImmer(initialValue) {
  var _React$useState = React.useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      val = _React$useState2[0],
      updateValue = _React$useState2[1];

  return [val, function (updater) {
    updateValue(produce(updater));
  }];
};

module.exports.useImmerReducer = function useImmerReducer(reducer, initialState, initialAction) {
  return React.useReducer(produce(reducer), initialState, initialAction);
};